<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :creators="creators"
        :farms="farms"
        @get-farms="getFarms"
        @submit="submit"
      />
      <presentation 
        :totals="results.totals ? results.totals : {}"
      />
    </div>
    <div class="col-md-12 px-0">
      <the-table 
        id="lactation-report"
        :dataItems="computedResults"
        :headers="headersForTable"
      />
    </div>
    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="computedResults.length"
      :excel="true"
      :data="computedExcel"
      :title="'Relatório de Curva de Lactação'"
      @export-pdf="PDFExport"
    />
  </div>
</template>

<script>
import Presentation from "./Presentation.vue";
import ReportFilters from "./ReportFilters.vue";
import {mapActions, mapState} from "vuex";
import TheTable from '@/components/layout/TheTable.vue';
import ButtonExport from "@/components/layout/ButtonExport";
import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"LactationCurve",
  components: { 
    Presentation,
    ReportFilters,
    TheTable,
    ButtonExport
  },
  data() {
    return {
      filter:{},
      headersForTable:[
        {text:"Código", value:"code"},
        {text:"Animal", value:"name"},
        {text:"DEL", value:"del"},
        {text:"Produção", value:"milk_production"},
        {text:"Média Diária", value:"average_day"},
      ]
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("farms", ["farms"]),
    ...mapState("lactation_curve", ["results"]),
    computedResults() {
      if(this.results.animals) {
        return this.results.animals.map(e => ({
          ...e,
          name:e.animal.register + " - " + e.animal.name,
          code:e.animal.code,
        }));
      } else {
        return [];
      }
    },
    computedExcel() {
      if(this.computedResults.length) {
        return this.computedResults.map((e, i) => ({
          "Total Produção": i === 0 ? this.results.totals.milk_production : undefined,
          "Média Produção Diária": i === 0 ? this.results.totals.average : undefined,
          "Dias": i === 0 ? this.results.totals.days : undefined,
          "Código": e.code,
          Animal: e.name,
          DEL: e.del,
          "Produção": e.milk_production,
          "Média Diária" : e.average_day
        }))
      } else {
        return [];
      }
    }
  },
  methods: {
    ...mapActions("lactation_curve", ["actionGetResults"]),
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("farms", ["actionGetFarms"]),
    async getFarms(person) {
      await this.actionGetFarms(person.id);
    },
    async submit(filter) {
      this.filter = filter;
      await this.actionGetResults({
        date:this.filter.date, 
        date_end:this.filter.date_end, 
        farms:this.filter.farms
      })
    },
    findFarms(x, y) {
      let results = [];
      x.forEach(item => {
        y.forEach(e => {
          if(e === item.id) {
            results.push(item.name)
          }
        })
      });
      return results.join();
    },
    async PDFExport(print = false) {
      const { date, date_end, person, farms } = this.filter;
      const totals = this.results.totals || {};
      return exportOfficialTablePdf({
        table: "#lactation-report", title: "CURVA DE LACTAÇÃO",
        details: [
          `Criador: ${person?.name || "-"}    Período: ${date || "-"} até ${date_end || "-"}`,
          `Propriedades: ${farms ? this.findFarms(this.farms, farms) : "-"}`,
          `Produção total: ${totals.milk_production || 0}    Média: ${totals.average || 0}`
        ],
        filename: `relatorio_curva_lactacao_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
  async mounted() {
    await this.actionGetCreators();
  }
}
</script>